import axios from 'axios'

export default {
  studentList: function (query: any = null) {
    return axios.get("/reports/student-list", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  courseWiseEnrollmentCount: function (query: any = null) {
    return axios.get("/reports/course-wise-enrollment-count", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  userWiseCourseEnrollment: function (query: any = null) {
    return axios.get("/reports/user-wise-course-enrollment", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  generateCertificateByAdmin: function (enrolment_id: any = null) {
    return axios.get("/reports/generate-certificate/" + enrolment_id)
      .then((response) => {
        return response.data
      })
  },
  orderList: function (params: any = null) {
    /*let params = {page: currentPage}
    params = {...query, ...params};*/

    return axios.get("/reports/orders", {
      params: params
    })
  },
  referAndEarnSaleReport: function (params: any = null) {
    return axios.get('/reports/refer-and-earn-sales-report', {
      params: params
    }).then((response) => {
      return response.data
    })
  },

  subscriptionsUserWatchDuration: function (params: any = null) {
    return axios.get("/reports/subscriptions/user-watch-duration", {
      params: params
    }).then((response) => {
      return response.data
    })
  },

  subscriptionsCourseWatchDuration: function (params: any = null) {
    return axios.get("/reports/subscriptions/course-watch-duration", {
      params: params
    }).then((response) => {
      return response.data
    })
  },

  affiliatePerformance: function (query: any = null) {
    return axios.get("/reports/affiliate/performance", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },

  affiliatePerformancePlanWise: function (query: any = null) {
    return axios.get("/reports/affiliate/performance/plan-wise", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },

  walletDisbursement: function (query: any = null) {
    return axios.get("/reports/point-disbursement", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },

  subscriptionRevenue: function (query: any = null) {
    return axios.get("/reports/subscription-revenue", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  subscriptionUsage: function (query: any = null) {
    return axios.get("/reports/subscription-usage", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  UnsubscriptionReport: function (query: any = null) {
    return axios.get("/reports/unsubscription", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  subscriptionUserDetailReport: function (query: any = null) {
    return axios.get("/reports/subscriptions/user-details", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
}
